import createIcon from '../../createIcon';

/**
 * @component @name Subway
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxN0MxNi4wNTIzIDE3IDE2LjUgMTYuNTUyMyAxNi41IDE2QzE2LjUgMTUuNDQ3NyAxNi4wNTIzIDE1IDE1LjUgMTVDMTQuOTQ3NyAxNSAxNC41IDE1LjQ0NzcgMTQuNSAxNkMxNC41IDE2LjU1MjMgMTQuOTQ3NyAxNyAxNS41IDE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguNSAxN0M5LjA1MjI4IDE3IDkuNSAxNi41NTIzIDkuNSAxNkM5LjUgMTUuNDQ3NyA5LjA1MjI4IDE1IDguNSAxNUM3Ljk0NzcyIDE1IDcuNSAxNS40NDc3IDcuNSAxNkM3LjUgMTYuNTUyMyA3Ljk0NzcyIDE3IDguNSAxN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjAxIDlIMTcuMDFWMTRINy4wMVY5Wk0xNy44IDIuOEMxNiAyLjA5IDEzLjg2IDIgMTIgMkMxMC4xNCAyIDggMi4wOSA2LjIgMi44QzMuNTMgMy44NCAyIDYuMDUgMiA4Ljg2VjIySDIyVjguODZDMjIgNi4wNSAyMC40NyAzLjg0IDE3LjggMi44Wk0xOCAxNS44OEMxOCAxNy4zMyAxNi44MiAxOC41IDE1LjM3IDE4LjVMMTYuNSAxOS42MlYyMEgxNUwxMy41IDE4LjVIMTAuNjdMOS4xNyAyMEg3LjVWMTkuNjJMOC42MiAxOC41QzcuMTggMTguNSA2IDE3LjMyIDYgMTUuODhWOUM2IDYuMzcgOSA2IDEyIDZDMTUuMzIgNiAxOCA2LjM4IDE4IDlWMTUuODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Subway = createIcon('Subway', [
  [
    'path',
    {
      d: 'M15.5 17C16.0523 17 16.5 16.5523 16.5 16C16.5 15.4477 16.0523 15 15.5 15C14.9477 15 14.5 15.4477 14.5 16C14.5 16.5523 14.9477 17 15.5 17Z',
      key: 's8p5oq',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 17C9.05228 17 9.5 16.5523 9.5 16C9.5 15.4477 9.05228 15 8.5 15C7.94772 15 7.5 15.4477 7.5 16C7.5 16.5523 7.94772 17 8.5 17Z',
      key: '1qak5m',
    },
  ],
  [
    'path',
    {
      d: 'M7.01 9H17.01V14H7.01V9ZM17.8 2.8C16 2.09 13.86 2 12 2C10.14 2 8 2.09 6.2 2.8C3.53 3.84 2 6.05 2 8.86V22H22V8.86C22 6.05 20.47 3.84 17.8 2.8ZM18 15.88C18 17.33 16.82 18.5 15.37 18.5L16.5 19.62V20H15L13.5 18.5H10.67L9.17 20H7.5V19.62L8.62 18.5C7.18 18.5 6 17.32 6 15.88V9C6 6.37 9 6 12 6C15.32 6 18 6.38 18 9V15.88Z',
      key: 'nyvdrt',
    },
  ],
]);

export default Subway;
